<template>
  <div class="shopping-cart-items">
    <h2 class="sr-only">Deine Lose im Warenkorb</h2>
    <template v-for="(item, index) in items" :key="index">
      <div v-if="showTicket(item.isFreeLot)" class="shopping-cart-items__item">
        <div class="shopping-cart-items__item-header">
          <div class="shopping-cart-items__item-type">
            <div class="shopping-cart-items__item-type__img-section">
                <img :src="`${item.lotImageUrl}?${Date.now()}`" :alt="item.lotImageUrl.includes('/back') ? 'Abbildung deines ' + item.product + 'es' : item.product + '-Abbildung mit dem von Dir ausgewählten Motiv' ">

              <div class="shopping-cart-items__item-type__product-section">
                <h3 class="product-name">{{item.position == 1000 && item.isFreeLot? "Gratis-Los": item.product }}</h3>
                <span v-if="!item.isFreeLot" class="lotnumber">{{ item.lotNumber }}</span>
              </div>
            </div>
          </div>
          <div class="shopping-cart-items__detail-toggle">
            <a class="shopping-cart-items__item-footer icon-span" @click="showDetail(item, index)">
              <span :class="selectedItemIndex === index ? 'icon icon-chevron-up' : 'icon icon-chevron-down'"></span>
              <!-- <span class="detail">Details anzeigen</span> -->
            </a>
          </div>
        </div>
        <div class="shopping-cart-items__item-footer">
          <div class="shopping-cart-items__item-footer__plan">
            <span> <span class="payment-interval">{{ getTranslation(item.paymentInterval) }}</span> zu zahlen</span>
          </div>
          <div class="shopping-cart-items__item-footer__spacer"></div>
          <div class="shopping-cart-items__item-footer__sum">
            <span class="price">{{ formatCurrency(item.price) }}</span>
          </div>
        </div>
        <div :class="{'animate__animated animate__fadeIn': selectedItemIndex === index, 'hide-detail': selectedItemIndex !== index}">
          <hr>
          <ShoppingCartDetail :key="item.id" :item="item" :show="selectedItemIndex === index" @close="showDetail(null, null)" />
        </div>
      </div>
      <div v-if="!item.isFreeLot" class="shopping-cart-items__delete">
        <button class="shopping-cart-items__item-delete icon-span" @click="showModal(item)">
          <span class="icon icon-trash"></span>
          <span>Los löschen</span>
        </button>
      </div>
    </template>
    <div class="shopping-cart__lot-container">
      <h2>Ein weiteres Los bestellen?</h2>
      <div class="grid" v-if="isLargeScreen">
        <a href="/lotterie/mein-gluecks-los">
          <img src="../assets/images/mgl.jpg" alt="Glücks-Los auswählen">
        </a>
        <a href="/lotterie/jahreslos">
          <img src="../assets/images/jl.jpg" alt="Jahreslos auswählen">
        </a>
        <a href="/lotterie/5-sterne-los">
          <img src="../assets/images/fsl.jpg" alt="5-Sterne-Los auswählen">
        </a>
      </div>
      <div v-else>
        <ImageSlider />
      </div>
    </div>
    <ShoppingCartConfirmationModal v-if="showModalFlag" :orderPositionId="selectedOrderPositionId" @updateCart="updateCart" @lotRemoved="removeItemFromList" @closeModal="closeModal" :item="selectedItem" />
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';

import ShoppingCartConfirmationModal from './ShoppingCartConfirmationModal.vue';
import ShoppingCartDetail from './ShoppingCartDetail.vue';
import ImageSlider from './ImageSlider.vue';

export default {
  setup() {
    const isLargeScreen = ref(window.matchMedia('(min-width: 768px)').matches);

    const checkScreenSize = () => {
      isLargeScreen.value = window.matchMedia('(min-width: 768px)').matches;
    };

    onMounted(() => {
      window.addEventListener('resize', checkScreenSize);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', checkScreenSize);
    });

    return {
      isLargeScreen
    };
  },
  props: {
    items: Array,
  },
  data() {
    return {
      showModalFlag: false,
      showDetailModalFlag: false,
      showItemDetail: false,
      selectedItemIndex: null,
      selectedOrderPositionId: null,
      modalFrontImage: '',
      modalBackImage: '',
      selectedItem: null, // Add selected item property
    };
  },
  methods: {
    getTranslation(type) {
      if (type.toLowerCase() == 'monthly') {
        return 'Monatlich';
      }
      if (type.toLowerCase() == 'once') {
        return 'Einmal';
      }
      return type;
    },
    formatCurrency(price) {
      return price.toLocaleString('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
      });
    },
    isNewUser() {
      return window.utag_data && window.utag_data['cp.utag_main_am_gratis']
    },
    showTicket(isFreeLot) {
      if (isFreeLot && this.isNewUser()) {
        return true;
      }
      if (!isFreeLot && this.isNewUser()) {
        return true;
      }
      return !(isFreeLot && !this.isNewUser());
    },
    showDetail(item, index) {
      if (this.selectedItemIndex === index) {
        this.selectedItemIndex = null;
      } else {
        this.selectedItemIndex = index;
      }
    },
    async openModal(frontImage, backImage) {
      this.modalFrontImage = frontImage;
      this.modalBackImage = backImage;
      this.showDetailModalFlag = true;
    },
    async showModal(item) {
      this.selectedItem = item;
      this.selectedOrderPositionId = item.position;
      this.showModalFlag = true;
    },
    closeModal() {
      this.showModalFlag = false;
    },
    removeItemFromList(orderPositionId) {
      this.$emit('remove-item', orderPositionId);
    },
    updateCart() {
      this.$emit('update-cart');
    },
  },
  components: {
    ShoppingCartConfirmationModal,
    ShoppingCartDetail,
    ImageSlider
  },
};
</script>

<style lang="scss" scoped>
.shopping-cart__lot-container {
  background-color: var(--color-white);
  padding: 16px 32px 32px;

  h2 {
    font-family: "Aktion Mensch Bold";
    font-size: 20px;
    color: var(--color-red);
    margin-bottom: 20px;
    line-height: 25px;
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 16px;
    margin-top: 16px;

    @media (min-width: 768px) and (max-width: 1379px) {
      grid-gap: 14px;
    }

    @media (max-width: 480px) {
      grid-template-columns: 1fr;
    }
  }
  img {
    width: 100%;
  }
  
  a:focus-visible, a:focus {
      outline: 0.125rem solid #fff !important;
      outline-offset: 0.125rem;
      -webkit-box-shadow: 0 0 0 0.125rem #0060cc;
      box-shadow: 0 0 0 0.125rem #0060cc;
  }
}

.shopping-cart-items {
  display: grid;
  grid-gap: 14px;
  grid-template-rows: auto 1fr auto;
  font-family: "Aktion Mensch Regular";
  color: var(--color-text);
  overflow: hidden;

  &__delete {
    display: flex;
    cursor: pointer;
    justify-content: flex-end;
    padding-bottom: 16px;

    button {
      all: unset;
    }

    a,
    span {
      font-size: 14px;
      &.icon {
        margin-right: 8px;
      }
    }
  }

  .hide-detail {
    display: none;
  }

  &__item-delete {
    &:hover {
      color: var(--color-red);
    }

    &:focus-visible {
      outline: 0.125rem solid #fff !important;
      outline-offset: 0.125rem;
      -webkit-box-shadow: 0 0 0 0.125rem #0060cc;
      box-shadow: 0 0 0 0.125rem #0060cc;
      margin-right: 0.25rem;
    }
  }

  &__item-footer {
    display: grid;
    grid-template-columns: auto 1fr auto;
    padding: 20px 0 16px;
    grid-gap: 3px;

    &__spacer {
      border-bottom: 1.5px dotted var(--border-color);
    }
    &__plan {
      .payment-interval {
        text-transform: capitalize;
      }
    }
    &__spacer {
      margin-bottom: 2px;
    }
    &__sum {
      span {
        font-family: "Aktion Mensch Bold";
      }
    }

    @media (max-width: 767px) {
      padding: 16px 0 16px;
    }
  }
  &__item {
    padding: 16px 16px 0;
    background-color: var(--color-white);

    hr {
      height: 1px;
      background-color: #eeeeee;
      border: none;
      position: relative;
      margin: 11px -16px 16px;

      @media (max-width: 768px) {
        margin: 2px -16px 8px;
      }
    }
  }
  &__item-header {
    display: grid;
    grid-template-columns: 1fr auto;
  }

  &__item-type {
    &__img-section {
      display: grid;
      grid-template-columns: 93px 1fr;
      grid-gap: 12px;
      img {
        width: 100%;
      }
    }
    &__product-section {
      display: grid;
      line-height: 25px;
      .product-name {
        font-family: "Aktion Mensch Bold";
        font-size: 20px;
        color: var(--color-red);
      }
    }
  }
  &__detail-toggle {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
    a {
      font-size: 13px;
    }
    span {
      font-weight: bold;
    }
  }
}
</style>
